import { ComparisonTable } from 'components/ComparisonTable';
import { ComparisonRow } from 'components/ComparisonTable/row';
import * as React from 'react';
export default {
  ComparisonTable,
  ComparisonRow,
  React
};